require("./cardLastMovementsTableRow.scss");

const PropTypes = require("prop-types");

// @ Vendor
const React = require("react");
const { bindActionCreators } = require("redux");
const { connect } = require("react-redux");
const { Link } = require('react-router-dom');
const classnames = require("classnames");
// @ Helpers
const { formatText, FormattedText, getLanguage } = require("core/i18n").i18n;
const {
    formatAmountObject,
    getPlainAmountObject,
} = require("utilities/currencyHelper");
const { toCamelCase } = require("utilities/stringHelper");
const { getCategoryIcon } = require("constants/categories");
const { recordLink } = require("utilities/tagging");

//@ utilities
const {
    cardValidationRules,
} = require("utilities/accessHelperConditions/cards");
import FeatureTogglingRender from "components/conditionalRender/featureTogglingRender";
const {
    getCategoryIconURL,
} = require("utilities/expensesByCategories/categoriesUtilities");

const {
    LAVANDA,
    PFM,
    PFM_NEW_FEATURES,
} = require("constants/flagBasedFeatures");
// @ actions
const { open } = require("actions/categoryUpdate");
//@components
const { OKTableRow } = require("commonsComponents/OKTableRow");
const { OKTableCell } = require("commonsComponents/OKTableCell");
const { LabelDate } = require("commonsComponents/labelDate");
const {
    OneLineSymbolAmount,
} = require("commonsComponents/oneLineSymbolAmount");
const OKTag = require("components/commons/OKTag/OKTag");
const {
    OKIconCategorization,
} = require("commonsComponents/OKIconCategorization");
const {
    OKCollapsingToggler,
} = require("commonsComponents/OKCollapsingToggler");
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");
//@constants
const {
    CARD_MOVEMENTS_LIQUIDATED,
    CARD_MOVEMENTS_PENDING_LIQUIDATION,
    CARD_MOVEMENTS_PENDING_AUTHORIZED,
    CATEGORY_TYPE_CARD,
    CARD_CREDIT,
    HYPHEN,
    CARD_DEFERRED_PAYMENT,
    CARD_DEFERRABLE_PAYMENT,
    CARD_NOT_DEFERRABLE_PAYMENT,
} = require("constants/index");
const {
    LABEL_DATE_TODAY,
    LABEL_DATE_YESTERDAY,
} = require("constants/commonsComponents");
const {
    DEFERRAL_PAYMENT_CARD_ACTION_EVENT,
    DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT,
} = require("constants/tagging");
class CardLastMovementsTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.onRowClick = this.onRowClick.bind(this);
        this.handleOpenCategoriesModal =
            this.handleOpenCategoriesModal.bind(this);
    }

    componentDidMount() {
        const { id, cardDeepLinkResponse, immTransaction } = this.props;
        if (
            (cardDeepLinkResponse["description"] || "").trim() ===
                (immTransaction.get("description") || "").trim() &&
            cardDeepLinkResponse["date"] === immTransaction.get("date") &&
            cardDeepLinkResponse["amount"] ===
                immTransaction.getIn(["import", "amount"])
        ) {
            this.onRowClick(id);
            const element = document.getElementById(id);
            const ROW_HEADER_OFFSET = 250;
            element &&
                window.scrollTo(0, element.offsetTop + ROW_HEADER_OFFSET);
        }
    }

    onRowClick() {
        const { id, onRowClick } = this.props;

        onRowClick(id);
    }

    handleOpenCategoriesModal() {
        const { immTransaction, openCategoriesModal } = this.props;

        openCategoriesModal(
            CATEGORY_TYPE_CARD,
            immTransaction.get("cardId"),
            immTransaction.get("id"),
            immTransaction.get("category"),
            immTransaction.get("subcategory"),
            immTransaction.get("description"),
            immTransaction.get("date"),
            immTransaction.getIn(["balance", "amount"]),
            immTransaction.get("categoryCode"),
            immTransaction.get("subCategoryCode")
        );
    }

    mapContractStatus(status) {
        switch (status) {
            case CARD_MOVEMENTS_LIQUIDATED:
                return formatText("cardsTransactions-liquidated");
            case CARD_MOVEMENTS_PENDING_LIQUIDATION:
                return formatText("cardsTransactions-pendingLiquidation");
            case CARD_MOVEMENTS_PENDING_AUTHORIZED:
                return formatText("cardsTransactions-authorized");
            default:
                return toCamelCase(status.toLowerCase());
        }
    }

    render() {
        const { immTransaction, id, isExpanded, immCards, flagBasedFeatures } =
            this.props;
        const NEW_PFM_FEATURES = flagBasedFeatures.get(PFM_NEW_FEATURES);
        const settlementText = this.mapContractStatus(
            immTransaction.get("contractStatus")
        );
        const deferPaymentType = immTransaction.get("deferPaymentIndicator");
        const category = immTransaction.get("category");
        let subcategory = immTransaction.get("subcategory");
        const cardId = immTransaction.get("cardId");
        const transactionId = immTransaction.get("id");
        const immCard = immCards.getIn(["byId", cardId]);
        const subCategoryTextClass = classnames(
            "card-last-movements-table-row__category-tooltip-subtitle",
            {
                "card-last-movements-table-row__category-tooltip-paragraph":
                    immTransaction.get("canBeRecategorized"),
            }
        );

        const lengthDash = subcategory.split("_").length - 1;

        if (lengthDash === 1) {
            const numberSubCategory = subcategory.match(/\d/g).join("");
            const numberCategory = category.match(/\d/g).join("");
            subcategory = `category_${numberCategory}_${numberSubCategory}`;
        }

        let purchaseDeferralSection;
        let categoryTooltip;

        if (immCard.get("type") === CARD_CREDIT) {
            let tag = HYPHEN;

            switch (deferPaymentType) {
                case CARD_DEFERRABLE_PAYMENT:
                    if (
                        cardValidationRules.CARD_PAYMENT_PURCHASE_DEFERRAL.validator(
                            { immCard }
                        )
                    ) {
                        tag = (
                            <Link
                                className="account-information__link"
                                onClick={() =>
                                    flagBasedFeatures.get(LAVANDA) &&
                                    recordLink(
                                        window.utag_last_name,
                                        DEFERRAL_PAYMENT_CARD_ACTION_EVENT,
                                        DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT
                                    )
                                }
                                to={
                                    "/myprofile/cards/" +
                                    cardId +
                                    "/payment-purchase-deferral/" +
                                    transactionId
                                }
                            >
                                <OKTag
                                    content="cardsTransactions-defer"
                                    type="action"
                                />
                            </Link>
                        );
                    }
                    break;
                case CARD_DEFERRED_PAYMENT:
                    tag = (
                        <OKTag
                            content="cardsTransactions-deferred"
                            type="disabled"
                        />
                    );
                    break;
                case CARD_NOT_DEFERRABLE_PAYMENT:
                default:
                    tag = HYPHEN;
                    break;
            }

            purchaseDeferralSection = (
                <OKTableCell className="card-last-movements-table-row__cell-deferrable">
                    {tag}
                </OKTableCell>
            );
        }

        if (category) {
            const categoryIcon = NEW_PFM_FEATURES
                ? getCategoryIconURL(category)
                : getCategoryIcon(category);
            let editCategoryButton;
            let cantBeCategorizedInfoMessage;

            const categoryText = formatText(
                NEW_PFM_FEATURES
                    ? `categorized-${category}`
                    : `categories-${category}`
            );
            const subcategoryText = formatText(
                NEW_PFM_FEATURES
                    ? `categorized-${subcategory}`
                    : `${category}-${subcategory}`
            );

            if (immTransaction.get("canBeRecategorized")) {
                editCategoryButton = (
                    <div className="card-last-movements-table-row__category-tooltip-button">
                        <i
                            className="icon-editar account-last-movements-table-row__category-tooltip-edit-icon"
                            onClick={this.handleOpenCategoriesModal}
                        />
                    </div>
                );
            } else {
                cantBeCategorizedInfoMessage = (
                    <p className="card-last-movements-table-row__category-tooltip-paragraph">
                        <FormattedText
                            className="card-last-movements-table-row__category-info-message"
                            value="cardsTransactions-cantBeCategorizedInfoMessage"
                        />
                    </p>
                );
            }

            const categoryTooltipContent = (
                <div className="card-last-movements-table-row__category-tooltip">
                    <p className="card-last-movements-table-row__category-tooltip-title">
                        {categoryText}
                    </p>
                    <div className="card-last-movements-table-row__category-tooltip-wrapper">
                        <p className={subCategoryTextClass}>
                            {subcategoryText}
                        </p>
                        {editCategoryButton}
                    </div>
                    {cantBeCategorizedInfoMessage}
                </div>
            );

            const okCategoryIcon = (
                <span>
                    <OKIconCategorization
                        active={isExpanded}
                        iconUrl={NEW_PFM_FEATURES ? categoryIcon : null}
                        icon={categoryIcon}
                    />
                </span>
            );

            categoryTooltip = (
                <OKTooltip
                    content={categoryTooltipContent}
                    offset={[0, -30]}
                    target={okCategoryIcon}
                    type="custom"
                />
            );
        }
        const description = immTransaction.get("description");
        const plainAmountObject = getPlainAmountObject(
            immTransaction.get("import")
        );
        const language = getLanguage();

        return (
            <OKTableRow id={id} isExpanded={isExpanded}>
                <OKTableCell className="last-movements-table-row__cell-expand">
                    <OKCollapsingToggler
                        handlerToggle={this.onRowClick}
                        isExpanded={this.props.isExpanded}
                        isIconSecondary={true}
                    />
                </OKTableCell>
                <OKTableCell className="card-last-movements-table-row__cell-date">
                    <LabelDate
                        date={immTransaction.get("date")}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <FeatureTogglingRender notAllowedProductKey={PFM}>
                    <OKTableCell className="card-last-movements-table-row__cell-category">
                        {categoryTooltip}
                    </OKTableCell>
                </FeatureTogglingRender>
                <OKTableCell className="card-last-movements-table-row__cell-description">
                    <p className="card-last-movements-table-row__cell-description-content">
                        {description}
                    </p>
                </OKTableCell>
                <OKTableCell className="card-last-movements-table-row__cell-status">
                    {settlementText}
                </OKTableCell>
                {purchaseDeferralSection}
                <OKTableCell className="card-last-movements-table-row__cell-import">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(
                            plainAmountObject,
                            true
                        )}
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

CardLastMovementsTableRow.propTypes = {
    cardDeepLinkResponse: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    id: PropTypes.string,
    immCards: PropTypes.object,
    immTransaction: PropTypes.object,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
    openCategoriesModal: PropTypes.func,
};

CardLastMovementsTableRow.defaultProps = {
    className: "",
    onRowClick: function () {},
};

module.exports = connect(
    (state) => ({
        cardDeepLinkResponse: state.personeticsDeepLinks
            .get("cardMovementRequest")
            .toJS(),
        flagBasedFeatures: state.flagBasedFeatures,
        immCards: state.cards,
    }),
    (dispatch) => ({
        openCategoriesModal: bindActionCreators(open, dispatch),
    })
)(CardLastMovementsTableRow);
